import {stopLoading} from 'shared/actions/loading';
import {fetchEducator} from './educator';
import {fetchRecentStudents} from './students';
import {fetchActivities} from './activities';
import {pollEducatorVerification} from './educator';
import {setCollegeProfileUserInfo} from './college-profile';
import {fetchColleagues} from '../account-settings/actions/colleagues';
import {showSuccessfulCleverLogin} from 'shared/actions/clever';

const NUMBER_STUDENTS_TO_LOAD_FOR_DASHBOARD = 5;

export const loadApp = () => (dispatch) => {
  const promises = [
    dispatch(fetchActivities()),
    dispatch(fetchEducator()).then(({isVerified, institution, type, cleverId}) => {
      dispatch(fetchRecentStudents({type, limit: NUMBER_STUDENTS_TO_LOAD_FOR_DASHBOARD}));
      dispatch(setCollegeProfileUserInfo({institution, type}));

      if (!isVerified) {
        dispatch(pollEducatorVerification());
      } else {
        dispatch(fetchColleagues());
      }
      if (cleverId) {
        dispatch(showSuccessfulCleverLogin());
      }
    }),
  ];

  return Promise.all(promises).then(() => {
    dispatch(stopLoading());
  });
};
